export const checkInformedConsentStatus = (informedConsentResponse: any, setInformedConsentIsCompiled: (value: boolean) => void) => {
  if (
    informedConsentResponse?.type === 'single' ||
    informedConsentResponse?.type === 'couple' ||
    informedConsentResponse?.type === 'psychiatry' ||
    informedConsentResponse?.type === 'nutritionist'
  ) {
    setInformedConsentIsCompiled(
      informedConsentResponse.informedConsent !== null
    );
  } else if (informedConsentResponse?.type === 'underage') {
    setInformedConsentIsCompiled(
      informedConsentResponse.informedConsent !== null &&
      informedConsentResponse.otherInformedConsent !== null
    );
  }
};